"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentTransferClient = exports.hasCapability = exports.getCapabilities = exports.readDirectory = exports.getChecksum = exports.readChunkAsArrayBuffer = exports.readAsArrayBuffer = exports.getInfo = exports.removeDropzone = exports.createDropzone = exports.setBranding = exports.modifyTransfer = exports.showDirectory = exports.getFilesList = exports.getTransfer = exports.getAllTransfers = exports.showTransferMonitor = exports.showPreferencesPage = exports.showTransferManager = exports.showPreferences = exports.showAbout = exports.showSaveFileDialog = exports.showSelectFolderDialog = exports.showSelectFileDialog = exports.resumeTransfer = exports.stopTransfer = exports.removeTransfer = exports.deregisterStatusCallback = exports.registerStatusCallback = exports.deregisterActivityCallback = exports.registerActivityCallback = exports.startTransfer = exports.authenticate = exports.testSshPorts = exports.initSession = exports.init = exports.updateHttpGatewaySettings = exports.getStatus = exports.initDragDrop = exports.testConnection = void 0;
var messages_1 = require("../constants/messages");
var client_1 = require("../helpers/client/client");
var helpers_1 = require("../helpers/helpers");
var http_gateway_1 = require("../http-gateway");
var core_1 = require("../http-gateway/core");
var v2_1 = require("../http-gateway/v2");
var index_1 = require("../index");
var status_1 = require("./status");
var ws_1 = require("../helpers/ws");
var core_2 = require("../connect/core");
var connect_extension_1 = require("../helpers/connect-extension");
/**
 * Timeout for the lightweight Connect-extension probe in fallback flows. An installed +
 * enabled extension responds to the dispatched event within tens of milliseconds; capping
 * at 1.5s matches the Connect SDK's own internal probe (`detectExtension(1000)`) while
 * leaving a small buffer for slow systems. Decoupled from `retryTimeout` so the fallback
 * doesn't pay the full desktop-detection budget twice when the extension isn't present.
 */
var CONNECT_EXTENSION_DETECT_TIMEOUT = 1500;
/**
 * Check if IBM Aspera for Desktop connection works. This function is called by init
 * when initializing the SDK. This function can be used at any point for checking.
 *
 * @returns a promise that resolves if server can connect or rejects if not
 */
var testConnection = function () {
    if (index_1.asperaSdk.isReady || index_1.asperaSdk.useConnect) {
        return Promise.resolve(index_1.asperaSdk.globals.sdkResponseData);
    }
    return client_1.client.request('get_info')
        .then(function (data) {
        index_1.asperaSdk.globals.asperaSdkInfo = data;
        index_1.asperaSdk.globals.asperaAppVerified = true;
        return index_1.asperaSdk.globals.sdkResponseData;
    });
};
exports.testConnection = testConnection;
/**
 * RPC discovery used internally during IBM Aspera for desktop initialization to determine
 * the supported RPC methods of the user's version of IBM Aspera for desktop.
 *
 * For convenience, this function will return an empty [] if the SDK is currently configured to use
 * either HTTP Gateway or Connect transfer clients.
 *
 * @returns a promise that resolves if discovery is successful
 */
var rpcDiscover = function () {
    if (index_1.asperaSdk.useHttpGateway || index_1.asperaSdk.useConnect) {
        return Promise.resolve({ methods: [] });
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    return client_1.client.request('rpc.discover')
        .then(function (data) {
        index_1.asperaSdk.globals.rpcMethods = data.methods.map(function (m) { return m.name; });
        return data;
    })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.rpcDiscoverFailed, error);
        return Promise.reject((0, helpers_1.generateErrorBody)(messages_1.messages.rpcDiscoverFailed, error));
    });
};
/**
 * Initialize drag and drop. HTTP Gateway and Connect does not need to init.
 * Ignore if only HTTP Gateway
 * @param initCall - Indicate if called via init flow and should not reject
 *
 * @returns a promise that resolves if the initialization was successful or not
 */
var initDragDrop = function (initCall) {
    if (index_1.asperaSdk.useHttpGateway || index_1.asperaSdk.useConnect) {
        return Promise.resolve(true);
    }
    else if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    client_1.client.request('init_drag_drop')
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.dragDropInitFailed, error);
        if (initCall) {
            promiseInfo.resolver(false);
            (0, helpers_1.errorLog)(messages_1.messages.dragDropInitFailedInit, error);
        }
        else {
            promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.dragDropInitFailed, error));
        }
    });
    return promiseInfo.promise;
};
exports.initDragDrop = initDragDrop;
/**
 * Get the current SDK lifecycle status synchronously.
 *
 * @returns the current status, or undefined if no init has been called yet
 */
var getStatus = function () {
    return status_1.statusService.getStatus();
};
exports.getStatus = getStatus;
var setupAppId = function (options) {
    var _a;
    index_1.asperaSdk.globals.appId = (_a = options === null || options === void 0 ? void 0 : options.appId) !== null && _a !== void 0 ? _a : (0, helpers_1.randomUUID)();
    if (options === null || options === void 0 ? void 0 : options.supportMultipleUsers) {
        index_1.asperaSdk.globals.supportMultipleUsers = true;
        index_1.asperaSdk.globals.sessionId = (0, helpers_1.randomUUID)();
    }
};
var connectDesktop = function () {
    return index_1.asperaSdk.activityTracking.setup()
        .then(function () { return (0, exports.testConnection)(); })
        .then(function () { return rpcDiscover(); })
        .then(function () { return (0, exports.initDragDrop)(true); })
        .then(function () { return undefined; });
};
/**
 * Update HTTP Gateway settings.
 *
 * Partial updates are supported — fields left undefined keep their current value.
 *
 * @param settings the settings to update
 *
 * @example
 * // Before init:
 * updateHttpGatewaySettings({chunkSize: 5_000_000, concurrentUploads: 4});
 * initSession({appId: 'my-app', httpGatewaySettings: {url: '...', forceGateway: true}});
 *
 * @example
 * // At runtime:
 * updateHttpGatewaySettings({chunkSize: 5_000_000});
 */
var updateHttpGatewaySettings = function (settings) {
    if (typeof (settings === null || settings === void 0 ? void 0 : settings.chunkSize) === 'number') {
        v2_1.asperaHttpGateway.overwriteDefaultChunkSize(settings.chunkSize);
    }
    if (typeof (settings === null || settings === void 0 ? void 0 : settings.concurrentUploads) === 'number') {
        v2_1.asperaHttpGateway.overwriteDefaultConcurrentUploads(settings.concurrentUploads);
    }
};
exports.updateHttpGatewaySettings = updateHttpGatewaySettings;
/**
 * Initialize the SDK and connect to a transfer client. Returns a promise that resolves
 * when the transfer client is ready, or rejects if it cannot be reached.
 *
 * By default, the SDK connects to IBM Aspera for desktop. Set `connectSettings.useConnect`
 * to use IBM Aspera Connect instead. If `httpGatewaySettings` is provided, the gateway is
 * set up first — when `forceGateway` is true it becomes the sole transport; when false it
 * is set up as a supplementary transport and the primary client (Desktop or Connect) is
 * still initialized afterward.
 *
 * Note that the promise behavior varies by transfer client. For Desktop, the promise
 * remains pending until the application is detected. For Connect, the promise resolves
 * immediately after initialization begins — use {@link registerStatusCallback} to track
 * when Connect is actually ready. For a non-blocking alternative that provides consistent
 * lifecycle status events across all transfer clients, see {@link initSession}.
 *
 * @param options - Initialization options. See {@link InitOptions}.
 *
 * @returns a promise that resolves with SDK metadata when the transfer client is ready
 *
 * @example
 * init({ appId: 'my-app' })
 *   .then(() => {
 *     // Transfer client is ready — enable UI
 *   })
 *   .catch(error => {
 *     // Could not connect — prompt user to install or launch
 *   });
 */
var init = function (options) {
    var _a;
    setupAppId(options);
    var handleErrors = function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.serverError, error);
        index_1.asperaSdk.globals.asperaAppVerified = false;
        throw (0, helpers_1.generateErrorBody)(messages_1.messages.serverError, error);
    };
    var getDesktopStartCalls = function () {
        var _a, _b, _c;
        if (((_a = options === null || options === void 0 ? void 0 : options.connectSettings) === null || _a === void 0 ? void 0 : _a.fallback) && !((_b = options === null || options === void 0 ? void 0 : options.connectSettings) === null || _b === void 0 ? void 0 : _b.useConnect)) {
            var timeout = (_c = options === null || options === void 0 ? void 0 : options.retryTimeout) !== null && _c !== void 0 ? _c : 5000;
            return (0, helpers_1.withTimeout)(connectDesktop(), timeout)
                .then(function () { return index_1.asperaSdk.globals.sdkResponseData; })
                .catch(function () {
                ws_1.websocketService.disconnect();
                return (0, connect_extension_1.detectConnectExtension)(CONNECT_EXTENSION_DETECT_TIMEOUT).then(function (found) {
                    if (found) {
                        return (0, core_2.initConnect)(__assign(__assign({}, options.connectSettings), { hideIncludedInstaller: true }));
                    }
                    else if (index_1.asperaSdk.httpGatewayIsReady) {
                        return index_1.asperaSdk.globals.sdkResponseData;
                    }
                    throw (0, helpers_1.generateErrorBody)(messages_1.messages.serverError);
                });
            });
        }
        return connectDesktop()
            .then(function () { return index_1.asperaSdk.globals.sdkResponseData; })
            .catch(handleErrors);
    };
    var getTransferClientCalls = function () {
        var _a;
        return ((_a = options === null || options === void 0 ? void 0 : options.connectSettings) === null || _a === void 0 ? void 0 : _a.useConnect) ? (0, core_2.initConnect)(options.connectSettings) : getDesktopStartCalls();
    };
    if (((_a = options === null || options === void 0 ? void 0 : options.httpGatewaySettings) === null || _a === void 0 ? void 0 : _a.url) && !index_1.asperaSdk.globals.httpGatewayVerified) {
        (0, exports.updateHttpGatewaySettings)({
            chunkSize: options.httpGatewaySettings.chunkSize,
            concurrentUploads: options.httpGatewaySettings.concurrentUploads,
        });
        return (0, http_gateway_1.setupHttpGateway)(options.httpGatewaySettings.url).then(function () {
            var _a;
            if ((_a = options === null || options === void 0 ? void 0 : options.httpGatewaySettings) === null || _a === void 0 ? void 0 : _a.forceGateway) {
                return Promise.resolve(index_1.asperaSdk.globals.sdkResponseData);
            }
            return getTransferClientCalls();
        }).catch(function (error) {
            var _a;
            (0, helpers_1.errorLog)(messages_1.messages.httpInitFail, error);
            if ((_a = options === null || options === void 0 ? void 0 : options.httpGatewaySettings) === null || _a === void 0 ? void 0 : _a.forceGateway) {
                throw (0, helpers_1.generateErrorBody)(messages_1.messages.httpInitFail, error);
            }
            return getTransferClientCalls();
        });
    }
    return getTransferClientCalls();
};
exports.init = init;
/**
 * Initialize the SDK and begin detecting a transfer client. This function returns
 * immediately — lifecycle status is communicated asynchronously via {@link registerStatusCallback}.
 *
 * The SDK supports three transfer clients. By default, IBM Aspera for desktop is used.
 * Set `connectSettings.useConnect` to use IBM Aspera Connect instead. Desktop and Connect
 * are mutually exclusive — one or the other is detected, not both.
 *
 * ## HTTP Gateway
 *
 * HTTP Gateway is a server-side component that enables browser-based transfers without
 * a desktop application. It can be used in two modes:
 *
 * - **Sole transport** (`forceGateway: true`): HTTP Gateway is the only transport.
 *   No Desktop or Connect detection occurs. Status transitions to `RUNNING` when the
 *   gateway responds successfully, or `FAILED` if it does not.
 *
 * - **Supplementary transport** (`forceGateway: false`): HTTP Gateway is set up first
 *   as an additional transport for browser-based uploads and downloads. The primary
 *   transfer client (Desktop or Connect) is then detected separately. If HTTP Gateway
 *   setup fails, the primary client is still detected. Features that require a desktop
 *   application (native file dialogs, drag and drop, etc.) are only available when the
 *   primary client is running.
 *
 * ## Status lifecycle
 *
 * Use {@link registerStatusCallback} to receive status updates. Use {@link getStatus} to
 * read the current status synchronously at any time.
 *
 * **Desktop path**: `INITIALIZING` → `RUNNING` (app detected), `DEGRADED` (timeout but
 * HTTP Gateway is available as a supplementary transport), or `FAILED` (timeout, no
 * fallback). Detection continues in the background after `DEGRADED` or `FAILED` — if the
 * user launches the app later, the status transitions to `RUNNING`.
 *
 * **Connect path**: `INITIALIZING` → `RUNNING`, `FAILED`, `OUTDATED`, or
 * `EXTENSION_INSTALL` depending on the state of the Connect browser extension
 * and application.
 *
 * **HTTP Gateway path** (`forceGateway: true`): `INITIALIZING` → `RUNNING` or `FAILED`.
 *
 * @param options - Initialization options. See {@link InitOptions}.
 *
 * @example
 * // Use IBM Aspera for desktop (default)
 * registerStatusCallback(status => {
 *   if (status === 'RUNNING') {
 *     // Transfer client is ready — enable UI
 *   } else if (status === 'FAILED') {
 *     // Not detected — prompt user to install or launch
 *   }
 * });
 *
 * initSession({ appId: 'my-app' });
 *
 * @example
 * // Use IBM Aspera Connect
 * initSession({
 *   appId: 'my-app',
 *   connectSettings: {
 *     useConnect: true,
 *   },
 * });
 *
 * * @example
 * // Use HTTP Gateway only
 * initSession({
 *   appId: 'my-app',
 *   httpGatewaySettings: {
 *     url: 'https://example.com/aspera/http-gwy',
 *     forceGateway: true,
 *   },
 * });
 *
 * * @example
 * // Use IBM Aspera for desktop with automatic fallback to IBM Aspera Connect
 * initSession({
 *   appId: 'my-app',
 *   connectSettings: {
 *     fallback: true,
 *   },
 * });
 *
 * @example
 * // Use IBM Aspera for desktop with automatic fallback to HTTP Gateway
 * initSession({
 *   appId: 'my-app',
 *   httpGatewaySettings: {
 *     url: 'https://example.com/aspera/http-gwy',
 *   },
 * });
 *
 * * @example
 * // Use IBM Aspera for desktop or IBM Aspera Connect with automatic fallback to HTTP Gateway
 * initSession({
 *   appId: 'my-app',
 *   connectSettings: {
 *     fallback: true,
 *   },
 *   httpGatewaySettings: {
 *     url: 'https://example.com/aspera/http-gwy',
 *   },
 * });
 */
var initSession = function (options) {
    var _a, _b, _c, _d, _e;
    setupAppId(options);
    var retryInterval = (_a = options === null || options === void 0 ? void 0 : options.retryInterval) !== null && _a !== void 0 ? _a : 2000;
    var retryTimeout = (_b = options === null || options === void 0 ? void 0 : options.retryTimeout) !== null && _b !== void 0 ? _b : 5000;
    var hasFallback = ((_c = options === null || options === void 0 ? void 0 : options.connectSettings) === null || _c === void 0 ? void 0 : _c.fallback) && !((_d = options === null || options === void 0 ? void 0 : options.connectSettings) === null || _d === void 0 ? void 0 : _d.useConnect);
    var startDesktopDetection = function () {
        var onFallback = hasFallback
            ? function () {
                ws_1.websocketService.disconnect();
                (0, connect_extension_1.detectConnectExtension)(CONNECT_EXTENSION_DETECT_TIMEOUT).then(function (found) {
                    if (found) {
                        (0, core_2.initConnect)(__assign(__assign({}, options.connectSettings), { hideIncludedInstaller: true }));
                        var callbackId_1 = status_1.statusService.registerCallback(function (status) {
                            if (status === 'INITIALIZING') {
                                return;
                            }
                            status_1.statusService.deregisterCallback(callbackId_1);
                            if (status !== 'RUNNING') {
                                index_1.asperaSdk.globals.connect.removeEventListener();
                                index_1.asperaSdk.globals.connect.stop();
                                // Explicitly set status to FAILED since we go back to desktop mode
                                status_1.statusService.setStatus('FAILED');
                                status_1.statusService.resumePolling(connectDesktop, retryInterval);
                            }
                        });
                    }
                    else {
                        if (index_1.asperaSdk.httpGatewayIsReady) {
                            status_1.statusService.setStatus('DEGRADED');
                        }
                        else {
                            status_1.statusService.setStatus('FAILED');
                        }
                        status_1.statusService.resumePolling(connectDesktop, retryInterval);
                    }
                });
            }
            : undefined;
        status_1.statusService.startPolling(connectDesktop, retryInterval, retryTimeout, onFallback);
    };
    var startTransferClient = function () {
        var _a;
        if ((_a = options === null || options === void 0 ? void 0 : options.connectSettings) === null || _a === void 0 ? void 0 : _a.useConnect) {
            (0, core_2.initConnect)(options.connectSettings);
        }
        else {
            startDesktopDetection();
        }
    };
    // HTTP Gateway path
    if (((_e = options === null || options === void 0 ? void 0 : options.httpGatewaySettings) === null || _e === void 0 ? void 0 : _e.url) && !index_1.asperaSdk.globals.httpGatewayVerified) {
        status_1.statusService.setStatus('INITIALIZING');
        (0, exports.updateHttpGatewaySettings)({
            chunkSize: options.httpGatewaySettings.chunkSize,
            concurrentUploads: options.httpGatewaySettings.concurrentUploads,
        });
        (0, http_gateway_1.setupHttpGateway)(options.httpGatewaySettings.url).then(function () {
            var _a;
            if ((_a = options === null || options === void 0 ? void 0 : options.httpGatewaySettings) === null || _a === void 0 ? void 0 : _a.forceGateway) {
                status_1.statusService.setStatus('RUNNING');
                return;
            }
            startTransferClient();
        }).catch(function (error) {
            var _a;
            (0, helpers_1.errorLog)(messages_1.messages.httpInitFail, error);
            if ((_a = options === null || options === void 0 ? void 0 : options.httpGatewaySettings) === null || _a === void 0 ? void 0 : _a.forceGateway) {
                status_1.statusService.setStatus('FAILED');
                return;
            }
            startTransferClient();
        });
        return;
    }
    startTransferClient();
};
exports.initSession = initSession;
/**
 * Tests SSH port connectivity to a transfer server.
 *
 * Supported for Connect and IBM Aspera for desktop. Not supported for HTTP Gateway.
 *
 * @param options options including the remote host, SSH port, and timeout.
 *
 * @returns a promise that resolves if the SSH port test is successful and rejects otherwise.
 */
var testSshPorts = function (options) {
    var _a, _b;
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, helpers_1.throwError)(messages_1.messages.testSshPortsNotSupported);
    }
    if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.testSshPorts(options);
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        request: {
            remote_host: options.remote_host,
            ssh_port: (_a = options.ssh_port) !== null && _a !== void 0 ? _a : 33001,
            timeout_sec: (_b = options.timeout_sec) !== null && _b !== void 0 ? _b : 3,
        }
    };
    client_1.client.request('test_ssh_ports', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.testSshPortsFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.testSshPortsFailed, error));
    });
    return promiseInfo.promise;
};
exports.testSshPorts = testSshPorts;
/**
 * Authenticates a transfer specification against the remote server.
 *
 * Supported for Connect and IBM Aspera for desktop. Not supported for HTTP Gateway.
 *
 * @param transferSpec the transfer specification to authenticate.
 *
 * @returns a promise that resolves if authentication is successful and rejects otherwise.
 */
var authenticate = function (transferSpec) {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, helpers_1.throwError)(messages_1.messages.authenticateNotSupported);
    }
    if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.authenticate(transferSpec);
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    client_1.client.request('authenticate', { transfer_spec: transferSpec })
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.authenticateFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.authenticateFailed, error));
    });
    return promiseInfo.promise;
};
exports.authenticate = authenticate;
/**
 * Start a transfer
 *
 * @param transferSpec standard transferSpec for transfer
 * @param asperaSdkSpec IBM Aspera settings when starting a transfer.
 *
 * @returns a promise that resolves if transfer initiation is successful and rejects if transfer cannot be started
 */
var startTransfer = function (transferSpec, asperaSdkSpec) {
    if (!(0, helpers_1.isValidTransferSpec)(transferSpec)) {
        return (0, helpers_1.throwError)(messages_1.messages.notValidTransferSpec, { transferSpec: transferSpec });
    }
    if (index_1.asperaSdk.useHttpGateway) {
        return transferSpec.direction === 'receive' ? (0, http_gateway_1.httpDownload)(transferSpec, asperaSdkSpec) : (0, http_gateway_1.httpUpload)(transferSpec, asperaSdkSpec);
    }
    else if (index_1.asperaSdk.useConnect) {
        /**
         * There is a bug in the Connect transfer client where Connect's HTTP server will no longer return ANY responses if a dialog was opened
         * when starting the transfer (ex: request or file overwrite confirmation).
         */
        if ((asperaSdkSpec === null || asperaSdkSpec === void 0 ? void 0 : asperaSdkSpec.allow_dialogs) !== false) {
            console.warn('[Aspera SDK] `allow_dialogs` was not set to `false` in AsperaSdkSpec and has been overridden. ' +
                'Connect dialogs block all subsequent HTTP responses. ' +
                'Set `allow_dialogs: false` explicitly to suppress this warning. ' +
                'More info: https://github.com/IBM/aspera-sdk-js/issues/196');
            asperaSdkSpec.allow_dialogs = false;
        }
        return index_1.asperaSdk.globals.connect.startTransferPromise(transferSpec, asperaSdkSpec).then(function (response) {
            response.transfer_specs[0].transfer_client = 'connect';
            return response.transfer_specs[0];
        });
    }
    else if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        transfer_spec: transferSpec,
        desktop_spec: asperaSdkSpec || {},
        app_id: index_1.asperaSdk.globals.appId,
    };
    client_1.client.request('start_transfer', payload)
        .then(function (data) {
        data.transfer_client = 'desktop';
        promiseInfo.resolver(data);
    })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.transferFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.transferFailed, error));
    });
    return promiseInfo.promise;
};
exports.startTransfer = startTransfer;
/**
 * Register a callback event for getting transfer updates
 *
 * @param callback callback function to receive transfers
 *
 * @returns ID representing the callback for deregistration purposes
 */
var registerActivityCallback = function (callback) {
    return index_1.asperaSdk.activityTracking.setCallback(callback);
};
exports.registerActivityCallback = registerActivityCallback;
/**
 * Remove a callback from the transfer callback
 *
 * @param id the ID returned by `registerActivityCallback`
 */
var deregisterActivityCallback = function (id) {
    index_1.asperaSdk.activityTracking.removeCallback(id);
};
exports.deregisterActivityCallback = deregisterActivityCallback;
/**
 * Register a callback for SDK lifecycle status changes. The callback fires immediately
 * with the current status (if one exists) and again whenever the status changes.
 *
 * Status values:
 *
 * - `INITIALIZING` — The SDK is detecting a transfer client.
 * - `RUNNING` — A transfer client is ready. Full functionality is available.
 * - `DEGRADED` — The primary transfer client (IBM Aspera for desktop) was not detected, but HTTP
 *   Gateway is available as a fallback. This is only available if XXX...
 * - `FAILED` — No transfer client could be reached. This could be because the user does
 *    not have a transfer client installed, it is not running, or in the case of HTTP Gateway,
 *    it was not reachable.
 * - `DISCONNECTED` — The transfer client was previously running but lost connection. This is specific
 *    to IBM Aspera for desktop. For example, if the user quits the app this status will trigger.
 * - `OUTDATED` — (Connect only) The Connect installation needs updating.
 * - `EXTENSION_INSTALL` — (Connect only) The browser extension needs to be installed.
 *
 * For IBM Aspera for desktop, detection continues in the background after `FAILED` or `DEGRADED`.
 * If the user launches the application later, the status transitions to `RUNNING`.
 *
 * @param callback callback function to receive status events
 *
 * @returns ID representing the callback for deregistration purposes
 *
 * @example
 * const id = registerStatusCallback(status => {
 *   if (status === 'RUNNING') {
 *     // Full functionality — enable all UI
 *   } else if (status === 'DEGRADED') {
 *     // Transfers work via HTTP Gateway
 *   } else if (status === 'FAILED') {
 *     // Nothing available — prompt user to install
 *   }
 * });
 *
 * // Later, to stop listening:
 * deregisterStatusCallback(id);
 */
var registerStatusCallback = function (callback) {
    return status_1.statusService.registerCallback(callback);
};
exports.registerStatusCallback = registerStatusCallback;
/**
 * Remove a callback from getting connection status events.
 *
 * @param id the ID returned by `registerStatusCallback`
 */
var deregisterStatusCallback = function (id) {
    status_1.statusService.deregisterCallback(id);
};
exports.deregisterStatusCallback = deregisterStatusCallback;
/**
 * Remove a transfer. This will stop the transfer if it is in progress.
 *
 * @param id transfer uuid
 *
 * @returns a promise that resolves if transfer is removed and rejects if transfer cannot be removed
 */
var removeTransfer = function (id) {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, core_1.httpRemoveTransfer)(id);
    }
    else if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.removeTransfer(id);
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        transfer_id: id,
    };
    client_1.client.request('remove_transfer', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.removeTransferFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.removeTransferFailed, error));
    });
    return promiseInfo.promise;
};
exports.removeTransfer = removeTransfer;
/**
 * Stop a transfer.
 *
 * @param id transfer uuid
 *
 * @returns a promise that resolves if transfer is stopped and rejects if transfer cannot be stopped
 */
var stopTransfer = function (id) {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, core_1.httpStopTransfer)(id);
    }
    if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.stopTransfer(id);
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        transfer_id: id,
    };
    client_1.client.request('stop_transfer', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.stopTransferFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.stopTransferFailed, error));
    });
    return promiseInfo.promise;
};
exports.stopTransfer = stopTransfer;
/**
 * Resume a paused or failed transfer.
 *
 * @param id transfer uuid
 * @param options resume transfer options
 *
 * @returns a promise that resolves with the new transfer object if transfer is resumed
 */
var resumeTransfer = function (id, options) {
    if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.resumeTransfer(id, options).then(function (response) {
            response.transfer_spec.transfer_client = 'connect';
            return response.transfer_spec;
        });
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        transfer_id: id,
        transfer_spec: options,
    };
    client_1.client.request('resume_transfer', payload)
        .then(function (data) {
        data.transfer_client = 'desktop';
        promiseInfo.resolver(data);
    })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.resumeTransferFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.resumeTransferFailed, error));
    });
    return promiseInfo.promise;
};
exports.resumeTransfer = resumeTransfer;
/**
 * Displays a file browser dialog for the user to select files.
 *
 * @param options file dialog options
 *
 * @returns a promise that resolves with the selected file(s) and rejects if user cancels dialog
 */
var showSelectFileDialog = function (options) {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, core_1.httpGatewaySelectFileFolderDialog)(options, false);
    }
    else if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.showSelectFileDialogPromise(options).then(function (response) {
            return response;
        });
    }
    else if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        options: options || {},
        app_id: index_1.asperaSdk.globals.appId,
    };
    client_1.client.request('show_file_dialog', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.showSelectFileDialogFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.showSelectFileDialogFailed, error));
    });
    return promiseInfo.promise;
};
exports.showSelectFileDialog = showSelectFileDialog;
/**
 * Displays a folder browser dialog for the user to select folders.
 *
 * @param options folder dialog options
 *
 * @returns a promise that resolves with the selected folder(s) and rejects if user cancels dialog
 */
var showSelectFolderDialog = function (options) {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, core_1.httpGatewaySelectFileFolderDialog)(options, true);
    }
    else if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.showSelectFolderDialogPromise(options).then(function (response) {
            return response;
        });
    }
    else if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        options: options || {},
        app_id: index_1.asperaSdk.globals.appId,
    };
    client_1.client.request('show_folder_dialog', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.showSelectFolderDialogFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.showSelectFolderDialogFailed, error));
    });
    return promiseInfo.promise;
};
exports.showSelectFolderDialog = showSelectFolderDialog;
/**
 * Displays a save file dialog for the user to choose a save location and filename.
 *
 * Supported for Connect and IBM Aspera for desktop. Not supported for HTTP Gateway.
 *
 * @param options save file dialog options
 *
 * @returns a promise that resolves with the selected save path and rejects if user cancels dialog
 */
var showSaveFileDialog = function (options) {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, helpers_1.throwError)(messages_1.messages.showSaveFileDialogNotSupported);
    }
    if (index_1.asperaSdk.useConnect) {
        var connectPromiseInfo_1 = (0, helpers_1.generatePromiseObjects)();
        index_1.asperaSdk.globals.connect.showSaveFileDialog({
            success: function (data) { return connectPromiseInfo_1.resolver(data); },
            error: function (error) { return connectPromiseInfo_1.rejecter(error); },
        }, options);
        return connectPromiseInfo_1.promise;
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        options: options || {},
        app_id: index_1.asperaSdk.globals.appId,
    };
    client_1.client.request('show_save_file_dialog', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.showSaveFileDialogFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.showSaveFileDialogFailed, error));
    });
    return promiseInfo.promise;
};
exports.showSaveFileDialog = showSaveFileDialog;
/**
 * Shows the about page of the transfer client.
 *
 * This is supported when using Connect or IBM Aspera for desktop, but not HTTP Gateway.
 *
 * @returns a promise that resolves when the about page is shown.
 */
var showAbout = function () {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, helpers_1.throwError)(messages_1.messages.showAboutNotSupported);
    }
    if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.showAbout();
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    client_1.client.request('show_about')
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.showAboutFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.showAboutFailed, error));
    });
    return promiseInfo.promise;
};
exports.showAbout = showAbout;
/**
 * Opens the IBM Aspera preferences page.
 *
 * @returns a promise that resolves when the preferences page is opened.
 */
var showPreferences = function () {
    if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.showPreferences();
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    client_1.client.request('open_preferences')
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.showPreferencesFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.showPreferencesFailed, error));
    });
    return promiseInfo.promise;
};
exports.showPreferences = showPreferences;
/**
 * Opens the transfer manager UI of the native transfer client.
 *
 * Supported for Connect and IBM Aspera for desktop. Not supported for HTTP Gateway.
 *
 * @returns a promise that resolves when the transfer manager is opened.
 */
var showTransferManager = function () {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, helpers_1.throwError)(messages_1.messages.showTransferManagerNotSupported);
    }
    if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.showTransferManager();
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    client_1.client.request('show_transfer_manager')
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.showTransferManagerFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.showTransferManagerFailed, error));
    });
    return promiseInfo.promise;
};
exports.showTransferManager = showTransferManager;
/**
 * Maps consumer-facing preference page names to the page names supported by
 * the IBM Aspera for desktop RPC server.
 */
var mapPreferencesPageForDesktop = function (page) {
    switch (page) {
        case 'network': return 'proxies';
        case 'bandwidth': return 'transfers';
        default: return page;
    }
};
/**
 * Opens the preferences page of the transfer client to a specific tab.
 *
 * Supported for Connect and IBM Aspera for desktop. Not supported for HTTP Gateway.
 *
 * @param options options including the page (tab) to open
 *
 * @returns a promise that resolves when the preferences page is opened.
 */
var showPreferencesPage = function (options) {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, helpers_1.throwError)(messages_1.messages.openPreferencesPageNotSupported);
    }
    if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.showPreferencesPage(options);
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        tab: mapPreferencesPageForDesktop(options.page),
    };
    client_1.client.request('open_preferences', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.openPreferencesPageFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.openPreferencesPageFailed, error));
    });
    return promiseInfo.promise;
};
exports.showPreferencesPage = showPreferencesPage;
/**
 * Opens the transfer rate monitor graph for a specific transfer.
 *
 * Supported for Connect and IBM Aspera for desktop. Not supported for HTTP Gateway.
 *
 * @param transferId the unique identifier of the transfer to monitor.
 *
 * @returns a promise that resolves when the transfer monitor is opened.
 */
var showTransferMonitor = function (transferId) {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, helpers_1.throwError)(messages_1.messages.showTransferMonitorNotSupported);
    }
    if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.showTransferMonitor(transferId);
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    client_1.client.request('show_transfer_monitor', { transfer_id: transferId })
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.showTransferMonitorFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.showTransferMonitorFailed, error));
    });
    return promiseInfo.promise;
};
exports.showTransferMonitor = showTransferMonitor;
/**
 * Get all transfers associated with the current application.
 *
 * @returns a promise that resolves with an array of transfers.
 */
var getAllTransfers = function () {
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    if (index_1.asperaSdk.useHttpGateway) {
        return Promise.resolve((0, core_1.httpGetAllTransfers)());
    }
    else if (index_1.asperaSdk.useConnect) {
        index_1.asperaSdk.globals.connect.getAllTransfers({
            success: function (data) {
                data.transfers.forEach(function (t) {
                    t.transfer_client = 'connect';
                });
                promiseInfo.resolver(data.transfers);
            }, error: function (error) {
                promiseInfo.rejecter(error);
            },
        });
        return promiseInfo.promise;
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var payload = {
        app_id: index_1.asperaSdk.globals.appId,
    };
    client_1.client.request('get_all_transfers', payload)
        .then(function (data) {
        data.forEach(function (t) {
            t.transfer_client = 'desktop';
        });
        promiseInfo.resolver(data);
    })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.getAllTransfersFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.getAllTransfersFailed, error));
    });
    return promiseInfo.promise;
};
exports.getAllTransfers = getAllTransfers;
/**
 * Get a specific transfer by ID.
 *
 * @param id transfer uuid
 *
 * @returns a promise that resolves with the transfer.
 */
var getTransfer = function (id) {
    if (index_1.asperaSdk.useHttpGateway) {
        var transfer = (0, core_1.httpGetTransfer)(id);
        if (transfer) {
            return Promise.resolve(transfer);
        }
        else {
            return Promise.reject((0, helpers_1.generateErrorBody)(messages_1.messages.getTransferFailed, { reason: 'Not found' }));
        }
    }
    else if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.getTransfer(id).then(function (response) {
            response.transfer_info.transfer_client = 'connect';
            return response.transfer_info;
        });
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        transfer_id: id,
    };
    client_1.client.request('get_transfer', payload)
        .then(function (data) {
        data.transfer_client = 'desktop';
        promiseInfo.resolver(data);
    })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.getTransferFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.getTransferFailed, error));
    });
    return promiseInfo.promise;
};
exports.getTransfer = getTransfer;
/**
 * Get paginated file-level progress for a specific transfer.
 *
 * @param id transfer uuid
 * @param pagination optional pagination options (limit and offset)
 *
 * @returns a promise that resolves with the paginated file progress list
 */
var getFilesList = function (id, pagination) {
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        transfer_id: id,
    };
    if (pagination) {
        payload.pagination = pagination;
    }
    client_1.client.request('get_files_list', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.getFilesListFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.getFilesListFailed, error));
    });
    return promiseInfo.promise;
};
exports.getFilesList = getFilesList;
/**
 * Opens and highlights the downloaded file in Finder or Windows Explorer. If multiple files,
 * then only the first file will be selected.
 *
 * @param id transfer uuid
 *
 * @returns a promise that resolves if the file can be shown and rejects if not
 */
var showDirectory = function (id) {
    if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.showDirectory(id);
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        transfer_id: id,
    };
    client_1.client.request('show_directory', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.showDirectoryFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.showDirectoryFailed, error));
    });
    return promiseInfo.promise;
};
exports.showDirectory = showDirectory;
/**
 * Modify the speed of a running transfer.
 *
 * @param id transfer uuid
 * @param options transfer rate options
 *
 * @returns a promise that resolves if the transfer rate can be modified and rejects if not
 */
var modifyTransfer = function (id, options) {
    if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.modifyTransfer(id, options).then(function (response) {
            return response;
        });
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        transfer_id: id,
        transfer_spec: options,
    };
    client_1.client.request('modify_transfer', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.modifyTransferFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.modifyTransferFailed, error));
    });
    return promiseInfo.promise;
};
exports.modifyTransfer = modifyTransfer;
/**
 * Set the custom branding template to be used by IBM Aspera. If the app is already
 * configured to use a different branding, then the branding template you specify will be
 * stored by the app, allowing the end user to switch at any point.
 *
 * @param id custom branding template id. This should be consistent across page loads.
 * @param options custom branding options
 *
 * @returns a promise that resolves if the branding was properly set.
 */
var setBranding = function (id, options) {
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var branding = {
        id: id,
        name: options.name,
        theme: options.theme,
    };
    var payload = {
        branding: branding,
    };
    client_1.client.request('update_branding', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.setBrandingFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.setBrandingFailed, error));
    });
    return promiseInfo.promise;
};
exports.setBranding = setBranding;
/**
 * Create a dropzone for the given element selector.
 *
 * @param callback the function to call once the files are dropped
 * @param elementSelector the selector of the element on the page that should watch for drop events
 * @param options options to configure which drag and drop events trigger the listener
 */
var createDropzone = function (callback, elementSelector, options) {
    var _a, _b, _c, _d, _e, _f;
    var resolvedOptions = {
        dragEnter: (_a = options === null || options === void 0 ? void 0 : options.dragEnter) !== null && _a !== void 0 ? _a : false,
        dragOver: (_b = options === null || options === void 0 ? void 0 : options.dragOver) !== null && _b !== void 0 ? _b : false,
        dragLeave: (_c = options === null || options === void 0 ? void 0 : options.dragLeave) !== null && _c !== void 0 ? _c : false,
        drop: (_d = options === null || options === void 0 ? void 0 : options.drop) !== null && _d !== void 0 ? _d : true,
        allowPropagation: (_e = options === null || options === void 0 ? void 0 : options.allowPropagation) !== null && _e !== void 0 ? _e : true,
        allowDefaultBehavior: (_f = options === null || options === void 0 ? void 0 : options.allowDefaultBehavior) !== null && _f !== void 0 ? _f : false,
    };
    if (index_1.asperaSdk.useConnect) {
        var connectOptions = {
            dragenter: resolvedOptions.dragEnter,
            dragover: resolvedOptions.dragOver,
            dragleave: resolvedOptions.dragLeave,
            drop: resolvedOptions.drop,
            allowPropagation: resolvedOptions.allowPropagation,
            disablePreventDefault: resolvedOptions.allowDefaultBehavior,
        };
        index_1.asperaSdk.globals.connect.setDragDropTargets(elementSelector, connectOptions, function (result) {
            callback({
                event: result.event,
                files: result.files,
            });
        });
        return;
    }
    var elements = document.querySelectorAll(elementSelector);
    if (!elements || !elements.length) {
        (0, helpers_1.errorLog)(messages_1.messages.unableToFindElementOnPage);
        return;
    }
    var handleEventDefaults = function (event) {
        if (!resolvedOptions.allowDefaultBehavior) {
            event.preventDefault();
        }
        if (!resolvedOptions.allowPropagation) {
            event.stopPropagation();
        }
    };
    var handleRequiredEventDefaults = function (event) {
        event.preventDefault();
        if (!resolvedOptions.allowPropagation) {
            event.stopPropagation();
        }
    };
    var registeredListeners = [];
    if (resolvedOptions.dragEnter) {
        registeredListeners.push({
            event: 'dragenter',
            callback: function (event) {
                handleEventDefaults(event);
                callback({ event: event });
            },
        });
    }
    if (resolvedOptions.dragLeave) {
        registeredListeners.push({
            event: 'dragleave',
            callback: function (event) {
                handleEventDefaults(event);
                callback({ event: event });
            },
        });
    }
    if (resolvedOptions.drop || resolvedOptions.dragOver) {
        registeredListeners.push({
            event: 'dragover',
            callback: function (event) {
                handleRequiredEventDefaults(event);
                if (resolvedOptions.dragOver) {
                    callback({ event: event });
                }
            },
        });
    }
    if (resolvedOptions.drop) {
        registeredListeners.push({
            event: 'drop',
            callback: function (event) {
                handleRequiredEventDefaults(event);
                if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length && event.dataTransfer.files[0]) {
                    var files = [];
                    for (var i = 0; i < event.dataTransfer.files.length; i++) {
                        var file = event.dataTransfer.files[i];
                        files.push({
                            lastModified: file.lastModified,
                            name: file.name,
                            size: file.size,
                            type: file.type
                        });
                    }
                    var payload = {
                        files: files,
                        app_id: index_1.asperaSdk.globals.appId,
                    };
                    if (index_1.asperaSdk.isReady) {
                        client_1.client.request('dropped_files', payload)
                            .then(function (data) { return callback({ event: event, files: data }); })
                            .catch(function (error) {
                            (0, helpers_1.errorLog)(messages_1.messages.unableToReadDropped, error);
                        });
                    }
                    else if (index_1.asperaSdk.httpGatewayIsReady) {
                        (0, core_1.handleHttpGatewayDrop)(event.dataTransfer.items, callback, event);
                    }
                }
            },
        });
    }
    elements.forEach(function (element) {
        registeredListeners.forEach(function (_a) {
            var event = _a.event, listener = _a.callback;
            element.addEventListener(event, listener);
        });
    });
    index_1.asperaSdk.globals.dropZonesCreated.set(elementSelector, registeredListeners);
};
exports.createDropzone = createDropzone;
/**
 * Remove dropzone.
 *
 * @param elementSelector the selector of the element on the page that should remove
 */
var removeDropzone = function (elementSelector) {
    var foundDropzone = index_1.asperaSdk.globals.dropZonesCreated.get(elementSelector);
    if (foundDropzone) {
        var elements_1 = document.querySelectorAll(elementSelector);
        foundDropzone.forEach(function (data) {
            if (elements_1 && elements_1.length) {
                elements_1.forEach(function (element) {
                    element.removeEventListener(data.event, data.callback);
                });
            }
        });
        index_1.asperaSdk.globals.dropZonesCreated.delete(elementSelector);
    }
};
exports.removeDropzone = removeDropzone;
/**
 * Get metadata about the IBM Aspera installation.
 *
 * @returns a promise that returns information about the user's IBM Aspera installation.
 */
var getInfo = function () {
    // Fetch the Connect application version on demand the first time it's requested.
    // Cached on `asperaSdk.globals.connectVersion` so subsequent calls return immediately.
    if (index_1.asperaSdk.useConnect && !index_1.asperaSdk.globals.connectVersion) {
        var promiseInfo_1 = (0, helpers_1.generatePromiseObjects)();
        index_1.asperaSdk.globals.connect.version()
            .then(function (info) {
            index_1.asperaSdk.globals.connectVersion = info === null || info === void 0 ? void 0 : info.version;
            promiseInfo_1.resolver(index_1.asperaSdk.globals.sdkResponseData);
        })
            .catch(function () {
            // Best-effort — leave connectVersion undefined if Connect's version() rejects.
            promiseInfo_1.resolver(index_1.asperaSdk.globals.sdkResponseData);
        });
        return promiseInfo_1.promise;
    }
    if (index_1.asperaSdk.useHttpGateway || index_1.asperaSdk.useConnect) {
        return Promise.resolve(index_1.asperaSdk.globals.sdkResponseData);
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    return Promise.resolve(index_1.asperaSdk.globals.sdkResponseData);
};
exports.getInfo = getInfo;
/**
 * Read an entire file as an array buffer (base64-encoded).
 *
 * Note: The maximum file size allowed is 50 MiB.
 *
 * @param path path to the file to read
 *
 * @returns a promise that resolves with the file data as a base64-encoded string and mime type
 */
var readAsArrayBuffer = function (path) {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, core_1.httpGatewayReadAsArrayBuffer)(path);
    }
    else if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.readAsArrayBuffer({ path: path });
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        request: {
            path: path,
        },
        app_id: index_1.asperaSdk.globals.appId,
    };
    client_1.client.request('read_as_array_buffer', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.readAsArrayBufferFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.readAsArrayBufferFailed, error));
    });
    return promiseInfo.promise;
};
exports.readAsArrayBuffer = readAsArrayBuffer;
/**
 * Read a chunk of a file as an array buffer (base64-encoded).
 *
 * Note: The maximum chunk size allowed is 50 MiB.
 *
 * @param path path to the file to read
 * @param offset offset to start reading the file, in bytes
 * @param chunkSize the size of the chunk to read, in bytes
 *
 * @returns a promise that resolves with the file chunk data as a base64-encoded string and mime type
 */
var readChunkAsArrayBuffer = function (path, offset, chunkSize) {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, core_1.httpGatewayReadChunkAsArrayBuffer)(path, offset, chunkSize);
    }
    else if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.readChunkAsArrayBuffer({ path: path, offset: offset, chunkSize: chunkSize });
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        request: {
            path: path,
            offset: offset,
            chunkSize: chunkSize,
        },
        app_id: index_1.asperaSdk.globals.appId,
    };
    client_1.client.request('read_chunk_as_array_buffer', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.readChunkAsArrayBufferFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.readChunkAsArrayBufferFailed, error));
    });
    return promiseInfo.promise;
};
exports.readChunkAsArrayBuffer = readChunkAsArrayBuffer;
/**
 * Get a checksum of the specified chunk size of the file.
 *
 * @param options checksum options including path, offset, chunkSize, and checksumMethod
 *
 * @returns a promise that resolves with the checksum information
 */
var getChecksum = function (options) {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, helpers_1.throwError)(messages_1.messages.getChecksumNotSupported);
    }
    if (index_1.asperaSdk.useConnect) {
        return index_1.asperaSdk.globals.connect.getChecksum(options);
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        request: {
            path: options.path,
            offset: options.offset || 0,
            chunkSize: options.chunkSize || 0,
            checksumMethod: options.checksumMethod || 'md5',
        },
        app_id: index_1.asperaSdk.globals.appId,
    };
    client_1.client.request('get_checksum', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.getChecksumFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.getChecksumFailed, error));
    });
    return promiseInfo.promise;
};
exports.getChecksum = getChecksum;
/**
 * Read the contents of a directory, returning all entries as a flat list.
 *
 * This API is only supported when using IBM Aspera for desktop.
 *
 * @param options options including the directory path, optional recursion depth, and filters
 *
 * @returns a promise that resolves with the directory entries and total count
 */
var readDirectory = function (options) {
    if (index_1.asperaSdk.useHttpGateway) {
        return (0, helpers_1.throwError)(messages_1.messages.readDirectoryNotSupported);
    }
    if (index_1.asperaSdk.useConnect) {
        return (0, helpers_1.throwError)(messages_1.messages.readDirectoryNotSupported);
    }
    if (!index_1.asperaSdk.isReady) {
        return (0, helpers_1.throwError)(messages_1.messages.serverNotVerified);
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    var payload = {
        request: {
            path: options.path,
            depth: options.depth,
            filters: options.filters,
        },
        app_id: index_1.asperaSdk.globals.appId,
    };
    client_1.client.request('read_directory', payload)
        .then(function (data) { return promiseInfo.resolver(data); })
        .catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.readDirectoryFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.readDirectoryFailed, error));
    });
    return promiseInfo.promise;
};
exports.readDirectory = readDirectory;
var supportsMethod = function (method) {
    // HTTP Gateway v2 specific overrides
    if (index_1.asperaSdk.useOldHttpGateway && (method === 'read_as_array_buffer' || method === 'read_chunk_as_array_buffer')) {
        return false;
    }
    // We currently do not support calculating file checksums when using HTTP Gateway. In theory it should be possible
    // to calculate this directly in the browser similar to how `readAsArrayBuffer()` is implemented.
    // HTTP Gateway also does not support showing native transfer client UI (about, preferences, etc.).
    if (index_1.asperaSdk.useHttpGateway && (method === 'get_checksum' || method === 'show_about' || method === 'open_preferences' || method === 'show_transfer_manager' || method === 'show_transfer_monitor' || method === 'authenticate' || method === 'test_ssh_ports' || method === 'show_save_file_dialog' || method === 'read_directory' || method === 'get_files_list' || method === 'update_branding' || method === 'show_directory' || method === 'modify_transfer' || method === 'resume_transfer')) {
        return false;
    }
    // Reading directory contents is only supported by the Desktop App (not Connect).
    if (index_1.asperaSdk.useConnect && (method === 'read_directory' || method === 'get_files_list' || method === 'update_branding')) {
        return false;
    }
    // HTTP Gateway and Connect do not have any RPC methods so fallback to true
    if (index_1.asperaSdk.useHttpGateway || index_1.asperaSdk.useConnect) {
        return true;
    }
    return index_1.asperaSdk.globals.rpcMethods.includes(method);
};
/**
 * Returns an object describing the high-level capabilities supported by the user's
 * transfer client (e.g. IBM Aspera for desktop, Connect, or HTTP Gateway).
 *
 * Use this for feature detection at a semantic level as capabilities may change depending on the
 * transfer client.
 *
 * Rather than caching the return value of this function, it's recommended to call it on the fly as
 * capabilities may change if your application supports multiple transfer clients. As a result, it's
 * recommend to use the slightly more ergonomic {@link hasCapability}.
 *
 * @returns an object with boolean flags for each capability.
 *
 * @example
 * // Conditionally render UI based on capabilities
 * const caps = asperaSdk.getCapabilities();
 * // Determine if your web application can render image previews for user selected files
 * if (caps.imagePreview) {
 *   asperaSdk.readAsArrayBuffer(path);
 * }
 */
var getCapabilities = function () {
    return {
        imagePreview: supportsMethod('read_as_array_buffer') && supportsMethod('read_chunk_as_array_buffer'),
        fileChecksum: supportsMethod('get_checksum'),
        showAbout: supportsMethod('show_about'),
        showPreferences: supportsMethod('open_preferences'),
        showTransferManager: supportsMethod('show_transfer_manager'),
        showTransferMonitor: supportsMethod('show_transfer_monitor'),
        authenticate: supportsMethod('authenticate'),
        testSshPorts: supportsMethod('test_ssh_ports'),
        showSaveFileDialog: supportsMethod('show_save_file_dialog'),
        readDirectory: supportsMethod('read_directory'),
        getFilesList: supportsMethod('get_files_list'),
        setBranding: supportsMethod('update_branding'),
        showDirectory: supportsMethod('show_directory'),
        folderUpload: !index_1.asperaSdk.useOldHttpGateway,
        modifyTransfer: supportsMethod('modify_transfer'),
        resumeTransfer: supportsMethod('resume_transfer'),
    };
};
exports.getCapabilities = getCapabilities;
/**
 * Check if the SDK and underlying transfer client supports a specific capability or feature.
 *
 * Capabilities depend on the transfer client being used (HTTP Gateway, Connect, or IBM Aspera for desktop).
 *
 * This function may be useful if you want to conditionally perform certain actions rather than
 * potentially getting an error.
 *
 * For example, only IBM Aspera for desktop supports traversing a folder's contents. An application can
 * check `hasCapability('readDirectory')` to optionally show a folder browser only when the feature is available.
 * For example, when a user does not have IBM Aspera for desktop installed and is using HTTP Gateway, your
 * application can disable this feature. Later, if that same user installs IBM Aspera for desktop, your application
 * will show the feature as enabled without any additional changes.
 *
 * @param capability the capability to check.
 *
 * @returns `true` if the capability is supported, `false` otherwise
 *
 * @example
 * ```typescript
 * // Determine if your web application can render image previews for user selected files
 * if (asperaSdk.hasCapability('imagePreview')) {
 *   const response = await asperaSdk.readAsArrayBuffer(path);
 * }
 * ```
 */
var hasCapability = function (capability) {
    return !!(0, exports.getCapabilities)()[capability];
};
exports.hasCapability = hasCapability;
var currentTransferClient = function () {
    if (index_1.asperaSdk.useHttpGateway) {
        return 'http-gateway';
    }
    else if (index_1.asperaSdk.useConnect) {
        return 'connect';
    }
    else if (index_1.asperaSdk.isReady) {
        return 'desktop';
    }
};
exports.currentTransferClient = currentTransferClient;
